import {ApplicationRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CadCartaocreditoComponent} from "../cad-cartaocredito/cad-cartaocredito.component";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {Location} from "@angular/common";
import {ContratoService} from "../../superadmin/services/contrato.service";
import {Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-pagamento-cartao',
  templateUrl: './pagamento-cartao.component.html',
  styleUrls: ['./pagamento-cartao.component.scss']
})
export class PagamentoCartaoComponent implements OnInit, OnDestroy {
  @Input() contrato: any = {};
  @Input() fatura: any = {};
  @Input() modal: boolean
  @ViewChild('cccompoment' , { static: false }) cccompoment: CadCartaocreditoComponent;
  erro: any;
  urlAutenticacao3DS: string;
  urlAutenticacao3DSSegura: SafeResourceUrl;
  private urlAutenticacao3DSConcluida: string;
  private pollingAutenticacao3DS: any;
  private sincronizandoAutenticacao3DS = false;
  private readonly messageHandler = (event: MessageEvent) => this.recebaRetorno3DS(event);
  constructor(private empresaService: EmpresasService, private _location: Location,
              private app: ApplicationRef,
              private contratoService: ContratoService, private router: Router,
              private sanitizer: DomSanitizer) { }
  pagando: boolean;
  pago: boolean;
  get faturaCancelada(): boolean {
    return !!this.fatura?.cancelada;
  }

  ngOnInit() {
    window.addEventListener('message', this.messageHandler, false);
    const { contrato, fatura } = window.history.state;

    if(contrato){
      this.contrato = contrato;
      this.fatura = fatura;
    }

    if(!this.contrato ||  !this.contrato.id){
      this.empresaService.obtenhaContrato().then( _contrato => {
        this.contrato = _contrato;
        if(!this.fatura?.codigo)
          this.fatura = _contrato.proximaFatura;
        this.processeEstadoFatura();
      })
    } else {
      setTimeout( () => {
        this.processeEstadoFatura();
      }, 0)
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageHandler, false);
    this.parePollingAutenticacao3DS();
  }

  get pagamentoCartaoPendente(): boolean {
    const status = String(this.fatura?.statusCartao || '').toUpperCase();
    return !this.fatura?.paga && !this.faturaCancelada &&
      ['CREATED', 'PROCESSING', 'PENDING', 'ACTIVE', 'REGISTERED', 'PENDING_AUTHENTICATION',
        'WAITING_AUTHENTICATION', 'AUTHORIZED', 'APPROVED', 'CONCLUDED'].indexOf(status) >= 0;
  }

  get autenticacao3DSPendente(): boolean {
    return this.pagamentoCartaoPendente && Boolean(this.fatura?.urlAutenticar);
  }

  faturaEstaPaga(){
    if(this.fatura?.paga || this.faturaCancelada) {
      if (this.cccompoment) {
        this.cccompoment.canceleProcessando();
        this.cccompoment.esconderPagar = true;
      }
      this.app.tick();
    }
  }

  private processeEstadoFatura(exibaErro: boolean = false) {
    this.pago = Boolean(this.fatura?.paga);
    this.atualizeAutenticacao3DS();

    if(this.autenticacao3DSPendente) this.iniciePollingAutenticacao3DS();
    else this.parePollingAutenticacao3DS();

    if(this.fatura?.paga || this.faturaCancelada) {
      this.faturaEstaPaga();
    } else if(this.pagamentoCartaoPendente) {
      this.fecheMensagemErro();
      this.cccompoment?.canceleProcessando();
    } else if(exibaErro) {
      this.erro = this.fatura?.motivoCartao ||
        'Pagamento não aprovado. Tente novamente ou utilize o Pix.';
      this.cccompoment?.canceleProcessando();
    }

    this.app.tick();
  }

  vinculeCartao(cartao: any) {
    this.fecheMensagemErro();

    if(this.pagando) return;

    this.urlAutenticacao3DSConcluida = null;
    this.pagando = true;
    this.contratoService.vinculeCartaoAssinatura(this.contrato, cartao, this.fatura).then( resp => {
      this.pagando = false;
      if (resp)
        Object.assign(this.fatura, resp);

      this.processeEstadoFatura(true);

      if(this.pagamentoCartaoPendente || !this.fatura?.paga)
        return;

      if(!this.modal){
        this.router.navigateByUrl('/admin/plano');
      }

    }).catch( erro => {
      this.erro = erro;
      this.pagando = false;
      this.cccompoment?.canceleProcessando();
    })

  }

  private atualizeAutenticacao3DS() {
    const url = this.autenticacao3DSPendente ? this.fatura?.urlAutenticar : null;
    if(!url || url === this.urlAutenticacao3DSConcluida) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
      return;
    }

    try {
      if(new URL(url).protocol !== 'https:') throw Error('URL 3DS inválida');
      this.urlAutenticacao3DS = url;
      this.urlAutenticacao3DSSegura = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } catch(e) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
    }
  }

  private recebaRetorno3DS(event: MessageEvent) {
    if(event.origin !== window.location.origin || event.data !== 'cellcoin-3ds-return') return;

    this.urlAutenticacao3DSConcluida = this.urlAutenticacao3DS;
    this.urlAutenticacao3DS = null;
    this.urlAutenticacao3DSSegura = null;
    this.sincronizeAutenticacao3DS();
  }

  private iniciePollingAutenticacao3DS() {
    if(!this.pollingAutenticacao3DS)
      this.pollingAutenticacao3DS = setInterval(() => this.sincronizeAutenticacao3DS(), 30000);
  }

  private sincronizeAutenticacao3DS() {
    if(!this.autenticacao3DSPendente) {
      this.parePollingAutenticacao3DS();
      return;
    }

    if(this.sincronizandoAutenticacao3DS) return;
    this.sincronizandoAutenticacao3DS = true;
    this.contratoService.sincronizeFatura(this.fatura).then((fatura: any) => {
      if(fatura) Object.assign(this.fatura, fatura);
      this.processeEstadoFatura(true);

      if(this.fatura?.paga && !this.modal)
        this.router.navigateByUrl('/admin/plano');
    }).catch(() => {}).then(() => this.sincronizandoAutenticacao3DS = false);
  }

  private parePollingAutenticacao3DS() {
    if(this.pollingAutenticacao3DS) clearInterval(this.pollingAutenticacao3DS);
    this.pollingAutenticacao3DS = null;
  }

  fecheMensagemErro() {
    delete this.erro;
  }

  voltar() {
    this._location.back();
  }
}
